import { JWMCard } from "@components/JWMCard/JWMCard";
import { CardImpression } from "@jmc/core/src/components";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import { CMSCardProps } from "@jwm/types/CMSCardProps";
import { default as cmsMapper } from "@utils/cms-mapper";
import React from "react";

import style from "../../style.module.scss";
import { trackingHelpersProps } from "../../types";

interface CardBlockProps {
    component: CMSCardProps;
    placement: string;
    trackingHelpers: trackingHelpersProps;
    sectionIndex?: number;
    sectionLinkColor?: string;
    siteSpecialty?: {
        type: string;
        title: string;
    };
}

export const CardBlock = ({
    component,
    placement,
    trackingHelpers,
    sectionIndex = 0,
    sectionLinkColor = "primary",
    siteSpecialty,
}: CardBlockProps): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();

    const cardProps = cmsMapper.mapJWMCardProps(component, jnjFullBranded);
    let targetUrl = null;
    const button = cardProps?.button?.[0];
    const url = button?.link?.url;
    if (button) {
        const linkType = button?.link?.external ? "external" : "internal";
        targetUrl = url?.startsWith("mailto") ? `${button?.link?.url}` : `${linkType}: ${button?.link?.url}`;
    }

    let mailtoTargetUrl = "";
    if (targetUrl?.startsWith("mailto")) {
        const endIndex = targetUrl.indexOf("@");
        const startIndex = targetUrl.indexOf(":");
        const newString = targetUrl.substring(startIndex + 1, endIndex);
        mailtoTargetUrl = targetUrl.replace(newString, "email");
        if (targetUrl.includes("?")) mailtoTargetUrl = mailtoTargetUrl.slice(0, mailtoTargetUrl.indexOf("?"));
        targetUrl = mailtoTargetUrl;
    }

    return (
        <div className={style.card__vertical_margins}>
            <CardImpression
                type={`general`}
                name={cardProps?.title as string}
                placement={`${placement}|card:(${cardProps?.title?.toString().toLowerCase()})`}
                position={trackingHelpers.position}
                targeturl={url?.startsWith("tel") ? "callto phone-number" : targetUrl}
            >
                <JWMCard
                    {...cardProps}
                    placement={placement}
                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                    sectionLinkColor={sectionLinkColor}
                    siteSpecialty={siteSpecialty}
                    isFullCardClickable={false}
                />
            </CardImpression>
        </div>
    );
};
